'use es6';

import formatMediumDate from 'I18n/utils/formatMediumDate';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
export function getSimpleDateText(timestamp) {
  const translatedDate = formatMediumDate(timestamp, 'userTz');
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    children: translatedDate
  });
}
getSimpleDateText.displayName = 'getSimpleDateText';